const routes = {
  home: '/',
  liveCamera: '/live-camera',
  map: '/map',
  playback: '/playback-video',
  playbackDesktopView: '/playback-video-destop-view',
  playbackDesktopViewOneCam: '/playback-video-destop-view-one-cam',
  review: '/review',
  smartReport: '/smart-report/:id',
  login: '/login',
  rtc: '/rtc',
  // camera: 'admin/camera',
  // cameraGroup: 'admin/camera_group',
  // addCamera: '/admin/camera/add_camera',
  // editCamera: '/admin/camera/edit/:id',
  // addGroup: '/admin/camera_group/add_group',
  // user: 'admin/user',
  // addUser: 'admin/user/add-new-user',
  // role: '/admin/role',
  infoUser: '/info-user',
  // waitConfirm: '/admin/wait-confirm',
  // editGroup: '/admin/camera_group/edit_group/:id',
  // wareHouse: '/admin/warehouse',
  // createWareHouse: '/admin/warehouse/create_warehouse',
  // editWareHouse: '/admin/warehouse/edit_warehouse/:id',
  // addCameraToWareHouse: '/admin/warehouse/add-camera/:id',
  registerSucces: '/register/verify-token/succes',
  forgotPassword: '/forgot-password',
  forgotPasswordVerify: '/forgot-password/verify-token',
  changePassword: '/forgot-password/change-password',
  changePasswordSucces: '/forgot-password/change-password/succes',
  register: '/register',
  registerVerify: '/register/verify-token',
  // addRole: '/admin/role/add_role',
  // addRoleById: '/admin/role/add_role/:id',
  // editRole: '/admin/role/edit/:id',
  // roleCamera: '/admin/camera_role',
  // userDetail: '/admin/user/info-detail',
  // services: '/admin/service',
  // subscribeService: '/admin/service/:id',
  // payService: '/admin/service/pay-service',
  notificationDetail: '/notification',
  // adminNotification: 'admin/notification',
  // historyAccess: '/history/access',
  // historyUser: '/history/user',
  // historyStream: '/history/live',
  // historyRecord: '/history/playback',
  // historyConfiguration: '/history/configuration',
  // historyEquipment: '/history/equipment',
  // historyError: '/history/error',
  errorPage: '/error/:id',
  notificationSetting:'/notification/setting',
  eventTracing: '/manager-ai/event-tracing',
  // timekeeping: '/manager-ai/timekeeping',
  notFound:'*',
  // companies: '/admin/companies',
  // changeInfoCompany: '/admin/companies/:id',
  // createCompany: '/admin/companies/create',
  changeNewPass: '/change-new-password',
  dashboard: '/dashboard',
  // cameraControl: '/manager-ai/camera-control',
  viewVideoLisencePlate: '/lisence-plate/view-video',
  // managerLisencePlate: '/lisence-plate/manager',
  // viewVideoFaceDetection: '/face-detection/view-video',
  // managerFaceDetection: '/face-detection/manager',

  viewVideoFaceDetection: '/face-detection/view-video',
  // managerFaceDetection: '/face-detection/manager',
  // viewVideoFireAlarm: '/fire-alarm/view-video',
  // managerFireAlarm: '/fire-alarm/manager',

  // // setDefault: '/admin/set-default',
  // assignFaceDetection:'/face-detection/assign',
  // objectFaceDetection:'/face-detection/object-manager',

  ticketManagement: '/ticket-management',
  ticketCreate: '/ticket-management/create',
  ticketUpdate: '/ticket-management/update/:id',
  aiAlert: '/ai-alert',
};

export default routes;